import { render, staticRenderFns } from "./KPIView.vue?vue&type=template&id=367b87c8&scoped=true&"
import script from "./KPIView.vue?vue&type=script&lang=js&"
export * from "./KPIView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367b87c8",
  null
  
)

export default component.exports